import { dbPut, normalizeCard, normalizeDeck } from '../core/db.js';
import { cardsOfCourse, visCourses } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, esc, renderRich, uid } from '../core/text.js';
import { checkAchievements } from '../progress/xp.js';
import { modal } from '../ui/modal.js';
import {
  fehlerBox, ladend, skelBestenliste, skelCollab, skelCommunitys, skelDeckKarten,
  skelDeckVorschau, skelDuell, skelFeed, wireErneut, zeigeInhalt, zeigeSkeleton,
} from '../ui/skeleton.js';
import { toast } from '../ui/toast.js';
import { refresh, setView } from '../ui/views.js';
import { cardsAsPayload, cloudChallengeCancel, cloudChallengeCreate, cloudChallengeRespond, cloudChallenges, cloudCollabAdd, cloudCollabPull, cloudCollabPush, cloudCommDecks, cloudCommJoin, cloudCommLeaderboard, cloudCommLeave, cloudCommMine, cloudCommSearch, cloudFeed, cloudFeedReact, cloudFriendDecks, cloudGetDeck, cloudLibrary, cloudLike, cloudMyDecks, cloudPreview, cloudPublish, cloudReport, cloudReview, cloudReviews, cloudUnpublish, cloudUpdate, openFriends, refreshSocial } from './api.js';
import { renderFriends } from './friends.js';
import { catAvatar, lbMetric, publicProfileModal } from './profile.js';

/* ══════════ Community-Ansicht ══════════ */
export function comSetTab(tab) { state.comTab = tab; renderCommunity(); }
export const SUBJECTS = ['Biologie', 'Medizin', 'Jura', 'Informatik', 'Mathe', 'Physik', 'Chemie', 'Sprachen', 'Psychologie', 'Wirtschaft', 'Geschichte', 'Technik'];
export function renderSubjectChips() {
  const box = $('#com-subjects'); if (!box) return;
  box.innerHTML = [['', 'Alle Fächer'], ...SUBJECTS.map((s) => [s, s])]
    .map(([v, l]) => `<button class="subject-chip ${state.comSubject === v ? 'active' : ''}" data-subj="${esc(v)}">${esc(l)}</button>`).join('');
  $$('#com-subjects .subject-chip').forEach((b) => b.onclick = () => { state.comSubject = b.dataset.subj; renderCommunity(); });
}
export async function renderCommunity() {
  $('#com-need').classList.add('hidden'); $('#com-body').classList.remove('hidden');
  $$('#view-community .com-tab').forEach((b) => b.classList.toggle('active', b.dataset.com === state.comTab));
  const isLib = state.comTab === 'library';
  const isComm = state.comTab === 'communities';
  const isFeed = state.comTab === 'feed';
  const isCollab = state.comTab === 'collab';
  const isPeople = state.comTab === 'people';
  $('#com-toolbar').style.display = isLib ? '' : 'none';
  $('#com-subjects').style.display = isLib ? '' : 'none';
  $('#com-grid').classList.toggle('hidden', isComm || isFeed || isCollab || isPeople);
  $('#com-communities').classList.toggle('hidden', !isComm);
  $('#com-feed').classList.toggle('hidden', !isFeed);
  $('#com-collab').classList.toggle('hidden', !isCollab);
  $('#com-people').classList.toggle('hidden', !isPeople);
  if (isLib) renderSubjectChips();
  if (isComm) { renderCommunities(); return; }
  if (isFeed) { renderFeed(); return; }
  if (isCollab) { renderCollab(); return; }
  if (isPeople) {
    // Freunde-System in die Community eingebettet (Reiter „Freunde")
    const host = $('#com-people'); const body = $('#friends-body'); const need = $('#friends-need');
    if (body && body.parentElement !== host) host.appendChild(body);
    if (need && need.parentElement !== host) host.insertBefore(need, host.firstChild);
    renderFriends();
    return;
  }
  const grid = $('#com-grid');
  /* Statt einer Textzeile „Lädt…" das Raster, das gleich kommt. Vorher sprang
     die Seite von einer Zeile auf ein volles Kartenraster – dieser Sprung ist
     der eigentliche Grund, warum sich das Laden unfertig anfühlte.

     Vier Karten, nicht zwölf: die Trefferzahl kennt hier noch niemand. Wer
     viel vorzeichnet, liegt bei einer leeren Bibliothek weit daneben – und
     genau dann ist der Sprung am größten. */
  zeigeSkeleton(grid, skelDeckKarten(4));
  try {
    let decks = [], mine = false;
    if (isLib) {
      decks = (await cloudLibrary($('#com-search')?.value || '', $('#com-sort')?.value || 'likes', state.comSubject)).decks;
      zeigeInhalt(grid, decks.length ? decks.map((d) => deckCardHTML(d, false)).join('') : emptySoc(state.comSubject ? `Noch keine öffentlichen Decks im Fach „${state.comSubject}".` : 'Noch keine öffentlichen Decks. Sei die/der Erste und veröffentliche eins!'));
    } else if (state.comTab === 'friends') {
      decks = (await cloudFriendDecks()).decks;
      zeigeInhalt(grid, decks.length ? decks.map((d) => deckCardHTML(d, false)).join('') : emptySoc('Deine Freund:innen haben noch nichts geteilt. Schau später wieder vorbei.'));
    } else {
      mine = true;
      decks = (await cloudMyDecks()).decks;
      zeigeInhalt(grid, decks.length ? decks.map((d) => deckCardHTML(d, true)).join('') : emptySoc('Du hast noch keine Decks veröffentlicht. Tippe oben auf „Deck veröffentlichen".'));
    }
    comDecksCache = decks.map((d) => ({ ...d, _mine: mine }));
    grid.classList.toggle('mine', mine);
    wireDeckCards();
  } catch (e) {
    // Leer und kaputt sind zwei verschiedene Dinge. „Noch keine Decks" wäre
    // hier gelogen – es ist unbekannt, ob welche da sind.
    zeigeInhalt(grid, fehlerBox('Die Decks konnten nicht geladen werden: ' + e.message));
    wireErneut(grid, () => renderCommunity());
  }
}

/* ── Aktivitäts-Feed (in der Community) ── */
export function feedAgo(ts) {
  const s = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (s < 60) return 'gerade eben';
  if (s < 3600) return `vor ${Math.floor(s / 60)} min`;
  if (s < 86400) return `vor ${Math.floor(s / 3600)} h`;
  return `vor ${Math.floor(s / 86400)} Tag${Math.floor(s / 86400) === 1 ? '' : 'en'}`;
}
export async function renderFeed() {
  const box = $('#com-feed');
  box.innerHTML = `<div class="card-panel"><h3>Aktivitäten</h3>
    <p class="page-sub">Was du und deine Freund:innen gerade so treiben.</p>
    <div id="feed-list">${skelFeed(4)}</div></div>`;
  const listeVorab = $('#feed-list');
  ladend(listeVorab, true);
  try {
    const { feed } = await cloudFeed();
    const list = $('#feed-list');
    ladend(list, false);
    if (!feed.length) { list.innerHTML = emptySoc('Noch nichts los. Veröffentliche ein Deck oder füge Freund:innen hinzu – dann erscheint hier was.'); return; }
    list.innerHTML = feed.map((f) => `<div class="feed-item">
      <div class="feed-av">${catAvatar(null, null, 'feed-cat')}</div>
      <div class="feed-main">
        <div class="feed-text"><b>${esc(f.mine ? 'Du' : (f.username || 'Jemand'))}</b> ${esc(f.text || '')}</div>
        <div class="feed-meta">${feedAgo(f.at)}</div>
      </div>
      <button class="feed-react ${f.reacted ? 'on' : ''}" data-feed="${f.id}" title="Gefällt mir">❤ <span>${f.reactions || ''}</span></button>
    </div>`).join('');
    list.querySelectorAll('[data-feed]').forEach((b) => { b.onclick = async () => { try { await cloudFeedReact(b.dataset.feed); renderFeed(); } catch (e) { toast('Ging nicht: ' + e.message); } }; });
  } catch (e) {
    const l = $('#feed-list');
    if (l) { zeigeInhalt(l, fehlerBox('Der Feed konnte nicht geladen werden: ' + e.message)); wireErneut(l, () => renderFeed()); }
  }
}

/* ── Gemeinsame (kollaborative) Decks ── */
export async function renderCollab() {
  const box = $('#com-collab');
  box.innerHTML = `<div class="card-panel">
      <h3>Gemeinsame Decks</h3>
      <p class="page-sub">Erstellt zusammen ein Deck: Alle Mitglieder können Karten beitragen und den gemeinsamen Stand herunterladen.</p>
      <button class="btn-primary tiny" id="collab-new">＋ Gemeinsames Deck</button>
      <div id="collab-list" style="margin-top:14px">${skelCollab(2)}</div>
    </div>`;
  $('#collab-new').onclick = collabCreate;
  ladend($('#collab-list'), true);
  try {
    const { decks } = await cloudCollabPull();
    const list = $('#collab-list');
    ladend(list, false);
    if (!decks.length) { list.innerHTML = emptySoc('Noch kein gemeinsames Deck. Erstelle eins und lade Freund:innen dazu ein.'); return; }
    list.innerHTML = decks.map((d) => `<div class="collab-card">
      <div class="collab-head">
        <b>${esc(d.name)}</b>${d.owner ? ' <span class="collab-owner">Ersteller:in</span>' : ''}
        <span class="collab-meta">${d.subject ? esc(d.subject) + ' · ' : ''}${d.cards.length} Karten · v${d.version}</span>
      </div>
      <div class="collab-actions">
        <button class="btn-ghost outline tiny" data-cget="${d.id}">⬇ Als Kurs übernehmen</button>
        <button class="btn-ghost outline tiny" data-cpush="${d.id}">＋ Meine Karten beitragen</button>
        ${d.owner ? `<button class="btn-ghost outline tiny" data-cadd="${d.id}">👥 Mitglied hinzufügen</button>` : ''}
      </div>
    </div>`).join('');
    list.querySelectorAll('[data-cget]').forEach((b) => b.onclick = () => collabImport(decks.find((x) => x.id === b.dataset.cget)));
    list.querySelectorAll('[data-cpush]').forEach((b) => b.onclick = () => collabContribute(b.dataset.cpush));
    list.querySelectorAll('[data-cadd]').forEach((b) => b.onclick = () => collabAddMember(b.dataset.cadd));
  } catch (e) {
    const l = $('#collab-list');
    if (l) { zeigeInhalt(l, fehlerBox('Die gemeinsamen Decks konnten nicht geladen werden: ' + e.message)); wireErneut(l, () => renderCollab()); }
  }
}
export function collabCreate() {
  modal({
    title: 'Gemeinsames Deck',
    okText: 'Erstellen',
    body: `<div class="field"><label>Name</label><input class="input" id="cc-name" placeholder="z. B. Bio-Klausur WG"></div>
      <div class="field"><label>Fach (optional)</label><input class="input" id="cc-subj" placeholder="Biologie"></div>`,
    onOk: async () => {
      const name = $('#cc-name').value.trim();
      if (!name) { toast('Bitte einen Namen'); return false; }
      try { await cloudCollabAdd('', name, $('#cc-subj').value.trim(), ''); toast('Gemeinsames Deck erstellt ✦'); renderCollab(); }
      catch (e) { toast('Ging nicht: ' + e.message); return false; }
    },
  });
}
export function collabAddMember(deckId) {
  modal({
    title: 'Mitglied hinzufügen',
    okText: 'Hinzufügen',
    body: `<div class="field"><label>Nutzername der Freundin/des Freundes</label><input class="input" id="cm-user" placeholder="katzenname"></div>`,
    onOk: async () => {
      const u = $('#cm-user').value.trim();
      if (!u) { toast('Bitte einen Nutzernamen'); return false; }
      try { await cloudCollabAdd(deckId, '', '', u); toast('Mitglied hinzugefügt ✦'); }
      catch (e) { toast(e.message || 'Ging nicht'); return false; }
    },
  });
}
export async function collabImport(deck) {
  // gemeinsamen Stand als lokalen Kurs zum Lernen übernehmen
  const course = { id: uid(), name: deck.name + ' (gemeinsam)', emoji: '👥', created: Date.now(), archived: false };
  await dbPut('courses', course); state.courses.push(course);
  const dk = normalizeDeck({ id: uid(), courseId: course.id, name: deck.name, color: 0, created: Date.now(), archived: false });
  await dbPut('decks', dk); state.decks.push(dk);
  for (const c of deck.cards) {
    const rec = normalizeCard({ id: uid(), courseId: course.id, deckId: dk.id, front: { text: c.front || '', image: c.fImg || null }, back: { text: c.back || '', image: c.bImg || null }, hint: c.hint || '', cloze: !!c.cloze, tags: Array.isArray(c.tags) ? c.tags : [], created: Date.now() });
    await dbPut('cards', rec); state.cards.push(rec);
  }
  toast(`„${deck.name}" als Kurs übernommen ✦`);
  refresh();
}
export function collabContribute(deckId) {
  const decks = state.decks.filter((d) => !d.archived);
  if (!decks.length) { toast('Du hast noch keine Vorlesungen zum Beitragen.'); return; }
  modal({
    title: 'Meine Karten beitragen',
    okText: 'Beitragen',
    body: `<p class="page-sub">Deine Karten werden zum gemeinsamen Deck hinzugefügt (bestehende bleiben erhalten).</p>
      <div class="field"><label>Welche Vorlesung?</label><select class="select" id="cn-deck">
        ${decks.map((d) => { const co = state.courses.find((c) => c.id === d.courseId); return `<option value="${d.id}">${esc(co?.name || '')} › ${esc(d.name)}</option>`; }).join('')}
      </select></div>`,
    onOk: async () => {
      const dId = $('#cn-deck').value;
      const mine = cardsAsPayload(state.cards.filter((c) => c.deckId === dId));
      if (!mine.length) { toast('Diese Vorlesung hat keine Karten.'); return false; }
      try {
        const { decks: cur } = await cloudCollabPull();
        const target = cur.find((x) => x.id === deckId);
        const merged = [...(target?.cards || []), ...mine];
        await cloudCollabPush(deckId, merged);
        toast(`${mine.length} Karten beigetragen ✦`); renderCollab();
      } catch (e) { toast('Ging nicht: ' + e.message); return false; }
    },
  });
}

/* ── Communitys (Uni/Schule): beitreten, meine, Detail-Popup ── */
export async function renderCommunities() {
  const box = $('#com-communities');
  box.innerHTML = `
    <div class="card-panel">
      <h3>Community beitreten</h3>
      <p class="page-sub">Tritt deiner Uni oder Schule bei – dann seht ihr eine interne Bestenliste und findet gezielt Decks eurer Community.</p>
      <div class="opt-row"><input class="mini-input" id="comm-search" placeholder="Uni/Schule suchen oder neu anlegen…" style="max-width:340px">
        <button class="btn-primary tiny" id="comm-create">Beitreten / Anlegen</button></div>
      <div id="comm-search-res" class="comm-list"></div>
    </div>
    <div class="card-panel"><h3>Deine Communitys</h3><div id="comm-mine" class="comm-list">${skelCommunitys(2)}</div></div>`;
  let t = null;
  $('#comm-search').oninput = () => { clearTimeout(t); t = setTimeout(commSearch, 300); };
  $('#comm-create').onclick = async () => {
    const name = $('#comm-search').value.trim();
    if (name.length < 2) { toast('Bitte einen Namen (min. 2 Zeichen)'); return; }
    try { await cloudCommJoin({ name, kind: /schule|gymnasium|schul/i.test(name) ? 'schule' : 'uni' }); toast(`„${name}" beigetreten ✦`); $('#comm-search').value = ''; renderCommunities(); }
    catch (e) { toast(e.message); }
  };
  loadMyCommunities();
}
export async function commSearch() {
  const q = $('#comm-search')?.value.trim() || ''; const box = $('#comm-search-res'); if (!box) return;
  if (q.length < 2) { zeigeInhalt(box, ''); return; }
  // Bei einer Suche ist die Trefferzahl unbekannt – zwei angedeutete Zeilen
  // reichen als Zeichen „es läuft", ohne eine Menge vorzutäuschen.
  zeigeSkeleton(box, skelCommunitys(2));
  try {
    const { communities } = await cloudCommSearch(q);
    ladend(box, false);
    box.innerHTML = communities.length ? communities.map((c) => `<div class="comm-row">
      <button class="comm-open" data-id="${c.id}" data-name="${esc(c.name)}"><span class="comm-ico">${c.kind === 'schule' ? '🏫' : '🎓'}</span><span class="comm-name">${esc(c.name)}<small>${c.members} Mitglied${c.members === 1 ? '' : 'er'}</small></span></button>
      <button class="btn-primary tiny comm-join" data-id="${c.id}">Beitreten</button></div>`).join('')
      : '<p class="page-sub">Nichts gefunden – tippe auf „Beitreten / Anlegen", um es neu zu erstellen.</p>';
    wireCommRows(box);
  } catch (e) {
    zeigeInhalt(box, fehlerBox('Die Suche hat nicht geklappt: ' + e.message));
    wireErneut(box, () => commSearch());
  }
}
export async function loadMyCommunities() {
  const box = $('#comm-mine'); if (!box) return;
  ladend(box, true);
  try {
    const { communities } = await cloudCommMine();
    ladend(box, false);
    box.innerHTML = communities.length ? communities.map((c) => `<div class="comm-row">
      <button class="comm-open" data-id="${c.id}" data-name="${esc(c.name)}"><span class="comm-ico">${c.kind === 'schule' ? '🏫' : '🎓'}</span><span class="comm-name">${esc(c.name)}<small>${c.members} Mitglied${c.members === 1 ? '' : 'er'}</small></span></button>
      <button class="btn-ghost outline tiny comm-leave" data-id="${c.id}">Verlassen</button></div>`).join('')
      : '<p class="page-sub">Du bist noch keiner Community beigetreten.</p>';
    wireCommRows(box);
  } catch (e) {
    zeigeInhalt(box, fehlerBox('Deine Communitys konnten nicht geladen werden: ' + e.message));
    wireErneut(box, () => loadMyCommunities());
  }
}
export function wireCommRows(box) {
  box.querySelectorAll('.comm-open').forEach((b) => b.onclick = () => communityModal(b.dataset.id, b.dataset.name));
  box.querySelectorAll('.comm-join').forEach((b) => b.onclick = async () => { try { await cloudCommJoin({ id: b.dataset.id }); toast('Beigetreten ✦'); renderCommunities(); } catch (e) { toast(e.message); } });
  box.querySelectorAll('.comm-leave').forEach((b) => b.onclick = async () => { if (!confirm('Diese Community verlassen?')) return; try { await cloudCommLeave(b.dataset.id); toast('Verlassen'); renderCommunities(); } catch (e) { toast(e.message); } });
}
export let commModalState = { id: null, tab: 'board', sort: 'xp' };
export async function communityModal(id, name) {
  commModalState = { id, tab: 'board', sort: 'xp' };
  modal({ title: '🎓 ' + (name || 'Community'), okText: 'Schließen', body: skelBestenliste(5), onOk: () => {} });
  $('#modal-cancel').style.display = 'none';
  renderCommunityModal();
}
export async function renderCommunityModal() {
  const { id, tab } = commModalState;
  const body = $('#modal-body');
  body.innerHTML = `<div class="com-tabs" id="cm-tabs">
      <button class="com-tab ${tab === 'board' ? 'active' : ''}" data-cm="board">🏆 Bestenliste</button>
      <button class="com-tab ${tab === 'decks' ? 'active' : ''}" data-cm="decks">📚 Decks</button>
    </div><div id="cm-content">${tab === 'board' ? skelBestenliste(5) : skelDeckKarten(2)}</div>`;
  $$('#cm-tabs .com-tab').forEach((b) => b.onclick = () => { commModalState.tab = b.dataset.cm; renderCommunityModal(); });
  const content = $('#cm-content');
  ladend(content, true);
  try {
    if (tab === 'board') {
      const { entries, sort } = await cloudCommLeaderboard(id, commModalState.sort);
      content.innerHTML = `<div class="lb-tabs" id="cm-lbtabs" style="margin-bottom:12px">
          ${[['xp', 'XP'], ['cards', 'Karten'], ['streak', '🔥 Streak']].map(([v, l]) => `<button class="lb-tab ${commModalState.sort === v ? 'active' : ''}" data-s="${v}">${l}</button>`).join('')}
        </div>` + (entries.length
        ? `<div class="lb-list">${entries.map((e) => `<button class="lb-row ${e.me ? 'me' : ''}" data-uid="${e.user_id}">
            <span class="lb-rank">${e.rank}</span>${catAvatar(e.cat_color, e.accessory)}
            <span class="lb-name">${esc(e.name || e.username || 'Katze')}<small>Level ${e.level}</small></span>
            <span class="lb-val">${lbMetric(e, sort)}</span></button>`).join('')}</div>`
        : '<p class="page-sub">Noch keine Mitglieder mit Lernstand. Lernt ein paar Karten ✦</p>');
      $$('#cm-lbtabs .lb-tab').forEach((b) => b.onclick = () => { commModalState.sort = b.dataset.s; renderCommunityModal(); });
      $$('#cm-content [data-uid]').forEach((b) => b.onclick = () => publicProfileModal(b.dataset.uid));
    } else {
      content.innerHTML = `<div class="opt-row" style="margin-bottom:12px"><input class="mini-input" id="cm-search" placeholder="Decks dieser Community suchen…"></div><div id="cm-decks"></div>`;
      const load = async () => {
        const { decks } = await cloudCommDecks(id, $('#cm-search').value.trim());
        comDecksCache = decks.map((d) => ({ ...d }));
        $('#cm-decks').innerHTML = decks.length ? `<div class="com-grid">${decks.map((d) => deckCardHTML(d, false)).join('')}</div>` : '<p class="page-sub">Noch keine öffentlichen Decks in dieser Community.</p>';
        $$('#cm-decks .dc-view').forEach((b) => b.onclick = () => deckDetailModal(b.dataset.id, false));
        $$('#cm-decks .dc-get').forEach((b) => b.onclick = () => downloadDeck(b.dataset.id));
        $$('#cm-decks .dc-like').forEach((b) => b.onclick = async () => { try { const r = await cloudLike(b.dataset.id); b.classList.toggle('on', r.liked); b.querySelector('span').textContent = r.likes; } catch (e) { toast(e.message); } });
      };
      let t = null; $('#cm-search').oninput = () => { clearTimeout(t); t = setTimeout(load, 300); };
      load();
    }
  } catch (e) {
    content.innerHTML = fehlerBox('Die Community konnte nicht geladen werden: ' + e.message);
    wireErneut(content, () => renderCommunityModal());
  } finally { ladend(content, false); }
}

/* ── Lern-Duelle ── */
export async function renderChallenges() {
  const box = $('#fr-duels'); if (!box) return;
  zeigeSkeleton(box, skelDuell(2));
  try {
    const { challenges } = await cloudChallenges();
    ladend(box, false);
    if (!challenges.length) { box.innerHTML = '<p class="page-sub">Noch keine Duelle. Fordere eine:n Freund:in über den ⚔-Button heraus.</p>'; return; }
    box.innerHTML = challenges.map((c) => {
      if (c.incoming) return `<div class="duel">
        <div class="duel-head"><b>${esc(c.opp.name)}</b> fordert dich heraus!</div>
        <div class="duel-sub">${c.days} Tage · wer mehr Karten lernt, gewinnt</div>
        <div class="row-actions"><button class="btn-primary tiny duel-accept" data-id="${c.id}">Annehmen</button>
          <button class="btn-ghost outline tiny duel-decline" data-id="${c.id}">Ablehnen</button></div></div>`;
      if (c.status === 'pending') return `<div class="duel">
        <div class="duel-head">Duell mit <b>${esc(c.opp.name)}</b></div>
        <div class="duel-sub">Wartet auf Annahme…</div>
        <div class="row-actions"><button class="btn-ghost outline tiny duel-cancel" data-id="${c.id}">Zurückziehen</button></div></div>`;
      const total = Math.max(1, c.me.score + c.opp.score);
      const mePct = Math.round(c.me.score / total * 100);
      const done = c.status === 'done';
      const win = c.me.score > c.opp.score, tie = c.me.score === c.opp.score;
      const left = Math.max(0, Math.ceil((c.end_at - Date.now()) / 86400000));
      return `<div class="duel ${done ? (win ? 'won' : tie ? 'tie' : 'lost') : 'active'}">
        <div class="duel-head">⚔ Du vs <b>${esc(c.opp.name)}</b>${done ? (win ? ' · 🏆 gewonnen!' : tie ? ' · unentschieden' : ' · verloren') : ''}</div>
        <div class="duel-score"><span class="ds-me">${c.me.score}</span><div class="duel-bar"><i style="width:${mePct}%"></i></div><span class="ds-opp">${c.opp.score}</span></div>
        <div class="duel-sub">${done ? 'Beendet' : `noch ${left} Tag${left === 1 ? '' : 'e'} · Karten seit Start`}</div>
        <div class="row-actions"><button class="btn-ghost outline tiny duel-cancel" data-id="${c.id}">${done ? 'Entfernen' : 'Aufgeben'}</button></div></div>`;
    }).join('');
    $$('#fr-duels .duel-accept').forEach((b) => b.onclick = async () => { try { await cloudChallengeRespond(b.dataset.id, true); toast('Duell gestartet – viel Erfolg! ⚔'); renderChallenges(); } catch (e) { toast(e.message); } });
    $$('#fr-duels .duel-decline').forEach((b) => b.onclick = async () => { try { await cloudChallengeRespond(b.dataset.id, false); renderChallenges(); } catch (e) { toast(e.message); } });
    $$('#fr-duels .duel-cancel').forEach((b) => b.onclick = async () => { try { await cloudChallengeCancel(b.dataset.id); renderChallenges(); } catch (e) { toast(e.message); } });
  } catch (e) {
    zeigeInhalt(box, fehlerBox('Die Duelle konnten nicht geladen werden: ' + e.message));
    wireErneut(box, () => renderChallenges());
  }
}
export function challengeCreateModal(friendId, name) {
  modal({
    title: '⚔ Duell starten', okText: 'Herausfordern',
    body: `<p class="page-sub">Fordere <b>${esc(name || 'diese:n Freund:in')}</b> heraus. Wer im Zeitraum mehr Karten lernt, gewinnt.</p>
      <div class="field"><label>Zeitraum</label>
        <select class="select" id="duel-days"><option value="3">3 Tage</option><option value="7" selected>1 Woche</option><option value="14">2 Wochen</option><option value="30">1 Monat</option></select></div>`,
    onOk: async () => {
      try { await cloudChallengeCreate(friendId, +$('#duel-days').value); toast('Herausforderung gesendet ⚔'); renderChallenges(); }
      catch (e) { toast(e.message); return false; }
    },
  });
}
export const emptySoc = (m) => `<div class="empty"><img class="empty-img" src="assets/cat_study.png" alt=""><span>${esc(m)}</span></div>`;
export let comDecksCache = [];
export function starDisplay(sum, count) {
  const avg = count ? sum / count : 0;
  const full = Math.round(avg);
  const stars = '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
  return count
    ? `<div class="deck-stars"><span class="stars-on">${stars}</span> <b>${avg.toFixed(1)}</b> <span class="stars-n">(${count})</span></div>`
    : `<div class="deck-stars muted">☆☆☆☆☆ <span class="stars-n">noch keine Bewertung</span></div>`;
}
export function deckCardHTML(d, mine) {
  const likeCls = d.liked ? 'on' : '';
  const owner = mine ? 'von dir' : (d.owner ? 'von ' + esc(d.owner) : '');
  return `<div class="deck-card ${mine ? 'is-mine' : ''}" data-id="${d.id}">
    ${mine ? `<button class="deck-card-x dc-del" data-id="${d.id}" title="Deck entfernen">✕</button>` : ''}
    <div class="deck-card-top">
      <div class="deck-card-title">${esc(d.title)}</div>
      ${d.subject ? `<span class="deck-card-subj">${esc(d.subject)}</span>` : ''}
    </div>
    ${d.description ? `<div class="deck-card-desc">${esc(d.description)}</div>` : ''}
    ${starDisplay(d.rating_sum || 0, d.rating_count || 0)}
    <div class="deck-card-meta">
      <span>🗂 ${d.card_count}</span>
      <span>⬇ ${d.downloads || 0}</span>
      <span>❤ ${d.likes || 0}</span>
      ${owner ? `<span>${owner}</span>` : ''}
      ${d.visibility === 'friends' ? '<span class="deck-vis">nur Freunde</span>' : ''}
      ${mine && d.version > 1 ? `<span>v${d.version}</span>` : ''}
    </div>
    <div class="deck-card-actions">
      <button class="btn-primary tiny dc-view" data-id="${d.id}" data-mine="${mine ? 1 : 0}">👁 Vorschau</button>
      <button class="btn-ghost outline tiny dc-get" data-id="${d.id}">⬇ Laden</button>
      ${mine
        ? `<button class="btn-ghost outline tiny dc-upd" data-id="${d.id}">⟳ Aktualisieren</button>`
        : `<button class="dc-like ${likeCls}" data-id="${d.id}">❤ <span>${d.likes || 0}</span></button>`}
    </div>
  </div>`;
}
export function wireDeckCards() {
  $$('#com-grid .dc-view').forEach((b) => b.onclick = () => deckDetailModal(b.dataset.id, b.dataset.mine === '1'));
  $$('#com-grid .dc-get').forEach((b) => b.onclick = () => downloadDeck(b.dataset.id));
  $$('#com-grid .dc-like').forEach((b) => b.onclick = async () => {
    try {
      const r = await cloudLike(b.dataset.id);
      b.classList.toggle('on', r.liked); b.querySelector('span').textContent = r.likes;
    } catch (e) { toast(e.message); }
  });
  $$('#com-grid .dc-upd').forEach((b) => b.onclick = () => publishModal(null, comDecksCache.find((x) => x.id === b.dataset.id)));
  $$('#com-grid .dc-del').forEach((b) => b.onclick = async () => {
    if (!confirm('Dieses veröffentlichte Deck wirklich entfernen?')) return;
    try { await cloudUnpublish(b.dataset.id); await refreshSocial(); renderCommunity(); toast('Deck entfernt'); }
    catch (e) { toast(e.message); }
  });
}

/* ── Deck-Detail: Vorschau (erste 3 Karten) + Bewerten + Melden + Laden ── */
export async function deckDetailModal(id, mine) {
  const d = comDecksCache.find((x) => x.id === id) || {};
  modal({
    title: '👁 ' + (d.title || 'Deck'), okText: 'Herunterladen',
    // Deck-Vorschau: Kopfzeile, Kartenliste, Bewertungen – als Skeleton in
    // ungefähr der späteren Höhe, damit das Popup nicht von einer Zeile auf
    // volle Länge aufspringt.
    body: `<div id="dd-body">${skelDeckVorschau()}</div>`,
    onOk: async () => { await downloadDeck(id); },
  });
  const box = () => $('#dd-body');
  ladend(box(), true);
  try {
    const [prev, rev] = await Promise.all([cloudPreview(id), cloudReviews(id)]);
    let myStars = rev.myStars || 0;
    const cardsHTML = prev.preview.length
      ? prev.preview.map((c) => `<div class="dd-card">
          <div class="dd-q">${c.fImg ? `<img class="dd-img" src="${c.fImg}" alt="">` : ''}${c.cloze ? renderRich(c.front || '', { cloze: false }) : renderRich(c.front || '')}</div>
          <div class="dd-a">${c.bImg ? `<img class="dd-img" src="${c.bImg}" alt="">` : ''}${c.cloze ? renderRich(c.front || '', { cloze: true }) : renderRich(c.back || '')}</div></div>`).join('')
      : '<p class="page-sub">Keine Karten.</p>';
    const reviewsHTML = rev.reviews.length
      ? rev.reviews.slice(0, 6).map((r) => `<div class="dd-review"><span class="stars-on">${'★'.repeat(r.stars)}${'☆'.repeat(5 - r.stars)}</span> <b>${esc(r.username || '')}</b>${r.comment ? `<div class="dd-rev-c">${esc(r.comment)}</div>` : ''}</div>`).join('')
      : '<p class="page-sub">Noch keine Bewertungen.</p>';
    box().innerHTML = `
      ${d.subject ? `<span class="deck-card-subj">${esc(d.subject)}</span>` : ''}
      ${d.description ? `<p class="page-sub" style="margin-top:8px">${esc(d.description)}</p>` : ''}
      <div class="dd-summary">${starDisplay(Math.round((rev.avg || 0) * (rev.count || 0)), rev.count || 0)} · 🗂 ${prev.total} Karten${d.owner ? ' · von ' + esc(d.owner) : ''}</div>
      <h4 class="dd-h">Alle Karten (${prev.total})</h4>
      <div class="dd-cards">${cardsHTML}</div>
      ${mine ? '' : `<h4 class="dd-h">Deine Bewertung</h4>
        <div class="dd-stars" id="dd-stars">${[1, 2, 3, 4, 5].map((n) => `<button class="dd-star ${n <= myStars ? 'on' : ''}" data-n="${n}">★</button>`).join('')}</div>
        <textarea class="textarea" id="dd-comment" rows="2" placeholder="Kurzer Kommentar (optional)">${esc(rev.myComment || '')}</textarea>
        <div class="row-actions"><button class="btn-primary tiny" id="dd-save-review">Bewertung speichern</button>
          <button class="btn-ghost outline tiny" id="dd-report">⚑ Melden</button></div>`}
      <h4 class="dd-h">Bewertungen (${rev.count || 0})</h4>
      <div class="dd-reviews">${reviewsHTML}</div>`;
    if (!mine) {
      const paint = () => $$('#dd-stars .dd-star').forEach((s) => s.classList.toggle('on', +s.dataset.n <= myStars));
      $$('#dd-stars .dd-star').forEach((s) => s.onclick = () => { myStars = +s.dataset.n; paint(); });
      $('#dd-save-review').onclick = async () => {
        if (!myStars) { toast('Bitte Sterne vergeben'); return; }
        try { await cloudReview(id, myStars, $('#dd-comment').value.trim()); toast('Bewertung gespeichert ✦'); $('#modal').classList.add('hidden'); renderCommunity(); }
        catch (e) { toast(e.message); }
      };
      $('#dd-report').onclick = async () => {
        const reason = prompt('Warum meldest du dieses Deck? (kurz)');
        if (reason === null) return;
        try { await cloudReport(id, reason); toast('Danke – gemeldet. Wir schauen es uns an.'); }
        catch (e) { toast(e.message); }
      };
    }
  } catch (e) {
    box().innerHTML = fehlerBox('Die Vorschau konnte nicht geladen werden: ' + e.message);
    wireErneut(box(), () => deckDetailModal(id, mine));
  } finally { ladend(box(), false); }
}

/* ── Ein Community-Deck herunterladen → als neuer Kurs lokal (offline verfügbar) ── */
export async function downloadDeck(id) {
  toast('Lädt Deck…');
  let deck;
  try { deck = (await cloudGetDeck(id)).deck; } catch (e) { toast('Fehler: ' + e.message); return; }
  const cards = deck.cards || [];
  if (!cards.length) { toast('Dieses Deck hat keine Karten'); return; }
  const course = { id: uid(), name: deck.title || 'Geladenes Deck', emoji: '📥', created: Date.now(), archived: false };
  await dbPut('courses', course); state.courses.push(course);
  const dk = normalizeDeck({ id: uid(), courseId: course.id, name: deck.subject || 'Karten', created: Date.now() });
  await dbPut('decks', dk); state.decks.push(dk);
  for (const c of cards) {
    const rec = normalizeCard({ id: uid(), courseId: course.id, deckId: dk.id, front: { text: c.front || '', image: c.fImg || null }, back: { text: c.back || '', image: c.bImg || null }, hint: c.hint || '', cloze: !!c.cloze, tags: Array.isArray(c.tags) ? c.tags : [], created: Date.now() });
    await dbPut('cards', rec); state.cards.push(rec);
  }
  state.selCourse = course.id; state.openCourses.add(course.id); state.coll = null;
  toast(`„${deck.title}" geladen – ${cards.length} Karten sind jetzt offline verfügbar ✦`);
  refresh();
}

/* ── Deck veröffentlichen (Kurs auswählen) ── */
export function publishModal(preCourseId, updateDeck) {
  if (!state.me?.username) { toast('Leg zuerst in „Community › Freunde" einen Nutzernamen an'); openFriends(); return; }
  const courses = visCourses();
  if (!courses.length) { toast('Du hast noch keine Kurse zum Teilen'); return; }
  const upd = !!updateDeck;
  const pref = preCourseId && courses.some((c) => c.id === preCourseId) ? preCourseId : state.selCourse;
  const sel = pref && courses.some((c) => c.id === pref) ? pref : courses[0].id;
  const visOf = (v) => (updateDeck?.visibility || 'public') === v ? 'checked' : '';
  modal({
    title: upd ? '⟳ Deck aktualisieren' : '📤 Deck veröffentlichen', okText: upd ? 'Aktualisieren' : 'Veröffentlichen',
    body: `${upd ? `<p class="page-sub">Wähle den Kurs mit dem aktuellen Stand – das veröffentlichte Deck „${esc(updateDeck.title)}" wird überschrieben (neue Version).</p>` : ''}
           <div class="field"><label>Welcher Kurs?</label>
             <select class="select" id="pub-course">${courses.map((c) => `<option value="${c.id}" ${c.id === sel ? 'selected' : ''}>${esc(c.emoji || '📚')} ${esc(c.name)}</option>`).join('')}</select></div>
           <div class="field"><label>Titel</label><input class="input" id="pub-title" value="${esc(updateDeck?.title || '')}"></div>
           <div class="field"><label>Fach (optional)</label><input class="input" id="pub-subject" placeholder="z.B. Biologie" value="${esc(updateDeck?.subject || '')}"></div>
           <div class="field"><label>Beschreibung (optional)</label><textarea class="textarea" id="pub-desc" rows="3" placeholder="Worum geht's in diesem Deck?">${esc(updateDeck?.description || '')}</textarea></div>
           <div class="radio-row">
             <label class="radio-opt"><input type="radio" name="pubvis" value="public" ${upd ? visOf('public') : 'checked'}><span><strong>Öffentlich</strong>Jede:r findet es in der Bibliothek.</span></label>
             <label class="radio-opt"><input type="radio" name="pubvis" value="friends" ${visOf('friends')}><span><strong>Nur Freunde</strong>Nur deine Freund:innen sehen es.</span></label>
           </div>
           <p class="status" id="pub-count"></p>`,
    onOk: async () => {
      const courseId = $('#pub-course').value;
      const title = $('#pub-title').value.trim();
      if (!title) { toast('Bitte einen Titel'); return false; }
      const cards = cardsAsPayload(cardsOfCourse(courseId));
      if (!cards.length) { toast('Dieser Kurs hat keine Karten'); return false; }
      const visibility = document.querySelector('input[name="pubvis"]:checked').value;
      const payload = { title, subject: $('#pub-subject').value.trim(), description: $('#pub-desc').value.trim(), cards, visibility };
      try {
        if (upd) { await cloudUpdate({ id: updateDeck.id, ...payload }); toast(`„${title}" aktualisiert ✦ (${cards.length} Karten)`); }
        else { await cloudPublish(payload); toast(`„${title}" veröffentlicht ✦ (${cards.length} Karten)`); }
        await refreshSocial(); await checkAchievements();
        state.comTab = 'mine'; setView('community');
      } catch (e) { toast('Fehler: ' + e.message); return false; }
    },
  });
  const syncPub = () => {
    const c = state.courses.find((x) => x.id === $('#pub-course').value);
    if (c && !$('#pub-title').value) $('#pub-title').value = c.name;
    $('#pub-count').textContent = cardsAsPayload(cardsOfCourse($('#pub-course').value)).length + ' Karten werden geteilt';
  };
  setTimeout(() => { $('#pub-course').onchange = syncPub; syncPub(); }, 60);
}

